import React from 'react';
import {
    addProductNotification,
    createLiveChat,
    formatNumber,
    getData,
    isProductNotification,
    removeProductNotification,
} from '../utils';
import loadable from '@loadable/component';
import { Button, Checkbox, Dropdown, Image, Menu, Modal, Select, Space, Tooltip } from 'antd';
import Icon, {
    CheckOutlined,
    DownOutlined,
    InfoCircleOutlined,
    MailFilled,
    MailOutlined,
    PlusOutlined,
    TwitterOutlined,
} from '@ant-design/icons';
import {
    addOrRemoveFromComparison,
    addOrRemoveFromWishList,
    addToCart,
    fetchCart,
    updateCart,
} from '../reducer';
import WishListButton from './WishListButton';
import NumberInput from './NumberInput';
import CreateWishListModal from './CreateWishListModal';
import Spinner from './Spinner';

import { ReactComponent as FBSvg } from '../icons/facebook.svg';
import { ReactComponent as MessengerSvg } from '../icons/facebook-messenger.svg';
import { ReactComponent as PinterestSvg } from '../icons/pinterest.svg';
import { ReactComponent as ShareArrowSvg } from '../icons/share_or_raud.svg';
import { ReactComponent as ShareArrowFilledSvg } from '../icons/share_or_raud_filled.svg';
import { ReactComponent as ArrowFPSvg } from '../icons/arrow_fp.svg';

const ArrowFPIcon = (props) => <Icon component={ArrowFPSvg} {...props} />;

const LettkaupLoanCalc = loadable(
    () => import(/* webpackChunkName: "LettkaupLoanCalc" */ './LettkaupLoanCalc')
);
const UpsellModal = loadable(() => import(/* webpackChunkName: "UpsellModal" */ './UpsellModal'));

class ProductPrice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            product: props.product,
            name: props.name,
            sku: props.sku,
            priceInt: props.priceInt,
            price: props.price,
            specialPrice: props.specialPrice,
            specialPriceInt: props.specialPriceInt,
            defaultPrice: null,
            resize: this.props.resize,
            productNotification: null,
            basketId: props.basketId,
            quantityInCart: props.quantityInCart,
            syningareintak: props.syningareintak,
            upsellModalOpen: false,
            energyLabel: props.energyLabel,
            energyLabelModalOpen: false,
            wishLists: [],
            createWishListOpen: false,
            wishListDropdownOpen: false,
            shareDropdownOpen: false,
            selectedUpsell: [],
        };

        this.isProductNotification = isProductNotification.bind(this);
        this.addProductNotification = addProductNotification.bind(this);
        this.removeProductNotification = removeProductNotification.bind(this);
    }

    componentDidMount() {
        const { specialPriceInt, priceInt, product } = this.state;

        let price = priceInt;
        if (priceInt > specialPriceInt && specialPriceInt > 0) {
            price = specialPriceInt;
        }
        this.setState({ defaultPrice: price });
        if (this.props.isLoggedIn) this.checkProductNotification(product.id);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.productIdsOnWishList) {
            if (this.props.productIdsOnWishList.includes(this.state.product.id)) {
                if (!this.state.isOnWishList) this.setState({ isOnWishList: true });
            } else {
                if (this.state.isOnWishList) this.setState({ isOnWishList: false });
            }
        }
        if (this.props.productIdsInComparison) {
            if (this.props.productIdsInComparison.includes(this.state.product.id)) {
                if (!this.state.isInComparison) this.setState({ isInComparison: true });
            } else {
                if (this.state.isInComparison) this.setState({ isInComparison: false });
            }
        }
        if (this.props.quantityInCart !== prevProps.quantityInCart)
            this.setState({ quantityInCart: this.props.quantityInCart });

        if (this.props.wishLists !== this.state.wishLists && this.props.wishLists != null) {
            this.setState({ wishLists: this.props.wishLists });
        }
        if (this.props.isLoggedIn && this.props.isLoggedIn !== prevProps.isLoggedIn)
            this.checkProductNotification(this.state.product.id);
    }

    checkProductNotification = (id) => {
        (async () => {
            try {
                let content = await this.isProductNotification(id);
                if (content.response) {
                    this.setState({ productNotification: true });
                } else {
                    this.setState({ productNotification: false });
                }
            } catch (err) {
                console.log(err);
            }
        })();
    };

    quantityOptions = () => {
        let options = [];
        for (let i = 1; i <= 30; i++) {
            options[i] = (
                <Select.Option key={i} value={i}>
                    {i}
                </Select.Option>
            );
        }
        return options;
    };

    getTolvutekAvailability = () => {
        const {
            reykjavikQuantity,
            akureyriQuantity,
            stock10Quantity,
            disabled,
            productType,
            quantityMessage,
        } = this.state.product;
        let { expected } = this.state.product;
        let syningareintak = this.state.syningareintak;
        if (disabled || productType === 6 || productType === 7) return null;
        let syningareintakText = ' (aðeins 1 sýningareintak eftir, fæst með afslætti)';
        const productAvailable =
            reykjavikQuantity > 0 || akureyriQuantity > 0 || stock10Quantity > 0;
        if (productAvailable) expected = false;
        const totalAvailable = reykjavikQuantity + akureyriQuantity + stock10Quantity;
        return (
            <div className={'availability'}>
                <div className="spantext">Hvar er varan til?</div>
                {expected ? (
                    <div>
                        <div className="circle circle-yellow" />
                        <span>Væntanlegt í netverslun</span>
                    </div>
                ) : productAvailable ? (
                    <div>
                        <div className="circle circle-green" />
                        <span>
                            Til í netverslun
                            {syningareintak === '1' ||
                            syningareintak === '2' ||
                            syningareintak === '3'
                                ? '(sýningareintak)'
                                : totalAvailable > 5
                                  ? ''
                                  : ' (að klárast)'}
                        </span>
                    </div>
                ) : (
                    <div>
                        <div className="circle circle-red" />
                        <span>Ekki til í netverslun</span>
                    </div>
                )}
                {expected ? (
                    <div>
                        <div className="circle circle-yellow" />
                        <span>Væntanlegt í Reykjavík</span>
                    </div>
                ) : reykjavikQuantity <= 0 ? (
                    <div>
                        <div className="circle circle-red" />
                        <span>Ekki til í Reykjavík</span>
                    </div>
                ) : (
                    <div>
                        <div className="circle circle-green" />
                        <span>
                            Til í Reykjavík
                            {syningareintak === '1' || syningareintak === '3'
                                ? syningareintakText
                                : reykjavikQuantity > 5
                                  ? ''
                                  : ' (aðeins ' + reykjavikQuantity + ' eftir)'}
                        </span>
                    </div>
                )}
                {expected ? (
                    <div>
                        <div className="circle circle-yellow" />
                        <span>Væntanlegt á Akureyri</span>
                    </div>
                ) : akureyriQuantity <= 0 ? (
                    <div>
                        <div className="circle circle-red" />
                        <span>Ekki til á Akureyri</span>
                    </div>
                ) : (
                    <div>
                        <div className="circle circle-green" />
                        <span>
                            Til á Akureyri
                            {syningareintak === '2' || syningareintak === '3'
                                ? syningareintakText
                                : akureyriQuantity > 5
                                  ? ''
                                  : ' (aðeins ' + akureyriQuantity + ' eftir)'}
                        </span>
                    </div>
                )}
                {expected ? (
                    <div>
                        <div className="circle circle-yellow" />
                        <span>Væntanlegt í vöruhús</span>
                    </div>
                ) : stock10Quantity <= 0 ? (
                    <div>
                        <div className="circle circle-red" />
                        <span>Ekki til í vöruhúsi</span>
                    </div>
                ) : (
                    <div>
                        <div className="circle circle-green" />
                        <span>
                            Til í vöruhúsi (1-3 virkir dagar)
                            {stock10Quantity > 5 ? '' : ' (aðeins ' + stock10Quantity + ' eftir)'}
                        </span>
                    </div>
                )}
                {quantityMessage && <div dangerouslySetInnerHTML={{ __html: quantityMessage }} />}
            </div>
        );
    };

    getAvailability = () => {
        const {
            reykjavikQuantity,
            akureyriQuantity,
            eldhafQuantity,
            quantity,
            expected,
            disabled,
            productType,
            stock10Quantity,
        } = this.state.product;

        const specialOrder = this.state.product.custom4;
        const displayDateAvailable = this.props.displayDateAvailable;

        if (disabled || productType === 6 || productType === 7) return null;

        if (specialOrder && quantity <= 0) return null;

        return (
            <div className={'availability'}>
                <div className="spantext">Hvar er varan til?</div>
                {stock10Quantity ? (
                    stock10Quantity <= 0 ? (
                        <div>
                            <div className="circle circle-red"></div>
                            <span>Ekki til á lager Tölvuteks</span>
                        </div>
                    ) : (
                        <div>
                            <div className="circle circle-green"></div>
                            <span>Til á lager Tölvuteks ({stock10Quantity})</span>
                        </div>
                    )
                ) : (
                    ''
                )}
                {expected && quantity <= 0 ? (
                    !displayDateAvailable ? (
                        <Tooltip
                            placement="topLeft"
                            title="Engar upplýsingar eru um komutíma vöru. Afhendingartími vöru er breytilegur eftir framleiðendum en er að jafnaði 3-9 vikur."
                        >
                            <div>
                                <div className="circle circle-yellow" />
                                <span>Væntanlegt í netverslun / lager</span>
                                <InfoCircleOutlined className="date-expected-info" />
                            </div>
                        </Tooltip>
                    ) : (
                        <div>
                            <div className="circle circle-yellow" />
                            <span>Væntanlegt í netverslun / lager</span>
                        </div>
                    )
                ) : (
                    this.getQuantityStatus(
                        quantity,
                        'Til í netverslun / lager',
                        'Ekki til í netverslun / lager'
                    )
                )}
                {productType === 3
                    ? ''
                    : this.getQuantityStatus(
                          reykjavikQuantity,
                          'Til í verslun Borgartúni 37',
                          'Ekki til í verslun Borgartúni 37'
                      )}
                {productType === 3
                    ? ''
                    : this.getQuantityStatus(
                          eldhafQuantity,
                          'Til í verslun Eldhaf Glerártorgi',
                          'Ekki til í verslun Eldhaf Glerártorgi'
                      )}
                {akureyriQuantity <= 0
                    ? ''
                    : this.getQuantityStatus(akureyriQuantity, 'Til á söluskrifstofu Akureyri', '')}
            </div>
        );
    };

    getQuantityStatus = (quantity, availableText, notAvailableText) => {
        const text = quantity > 0 ? availableText : notAvailableText;
        return (
            <div>
                <div className={'circle circle-' + (quantity > 0 ? 'green' : 'red')} />
                <span>{`${text} ${
                    quantity > 5 || quantity <= 0
                        ? ''
                        : '(' + this.getQuantityMessage(quantity) + ')'
                }`}</span>
            </div>
        );
    };

    getQuantityMessage = (quantity) => {
        if (quantity >= 3) return 'örfá eftir';
        else return quantity;
    };

    toggleProductNotification = async () => {
        if (this.state.productNotification) {
            await this.removeProductNotification(this.state.product.id);
        } else {
            await this.addProductNotification(this.state.product.id);
        }
        this.setState({ productNotification: !this.state.productNotification });
    };

    getProductNotification = (availableQuantity) => {
        if (this.state.product.disabled || this.state.product.custom4) return null;
        if (this.state.productNotification === null && this.props.isLoggedIn) {
            return null;
        }
        if (availableQuantity <= 0) {
            const getEmailText = 'Fá tölvupóst þegar vara kemur á lager';
            return (
                <div id={'prod-notification'}>
                    {!this.props.isLoggedIn ? (
                        <a href={'/SetNotification?prodId=' + this.state.product.id}>
                            <MailOutlined />
                            {getEmailText}
                        </a>
                    ) : (
                        <div className={'link'} onClick={this.toggleProductNotification}>
                            {this.state.productNotification ? (
                                <span>
                                    <MailFilled />
                                    Hætta vöktun
                                </span>
                            ) : (
                                <span>
                                    <MailOutlined />
                                    {getEmailText}
                                </span>
                            )}
                        </div>
                    )}
                </div>
            );
        } else return null;
    };

    updateWishList = (e, id) => {
        this.props.store.dispatch(addOrRemoveFromWishList(e, id));
    };

    openChat = (e) => {
        e.preventDefault();
        e.stopPropagation();
        createLiveChat();
        return false;
    };

    updateComparison = (e, id) => {
        this.props.store.dispatch(addOrRemoveFromComparison(e, id));
        this.setState({ isInComparison: !this.state.isInComparison });
    };

    updateCart = (e, quantity) => {
        this.props.store.dispatch(
            updateCart(e, this.state.product.id, this.props.basketId, quantity)
        );
    };

    openUpsellModal = () => {
        this.setState({
            upsellModalOpen: true,
        });
    };

    hideUpsellModal = () => {
        this.setState({
            upsellModalOpen: false,
        });
    };

    getSpecialOrderPrice = (
        specialOrder,
        price,
        priceInt,
        specialPrice,
        specialPriceInt,
        discountInt,
        discountPercent
    ) => {
        if (specialOrder === 'SpecialOrderWithPrice') {
            if (specialPriceInt > 0 && priceInt > specialPriceInt) {
                return (
                    <div class="prices">
                        <div>
                            <div>
                                <div class="payment-header">Tilboðsverð</div>
                                <span class="discount-price">{specialPrice}</span>
                            </div>
                            <div>
                                <div class="payment-header old-price-header"></div>
                                <div class="old-price">{price}</div>
                            </div>
                            <div class="discount-info">
                                Afsláttur:{' '}
                                <span class="amount">{formatNumber(discountInt, true)}</span>{' '}
                                {Math.round(discountPercent) > 0 && (
                                    <span class="amount discount">
                                        {Math.round(discountPercent)}%
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className={'prices'}>
                        <span className="price">{price}</span>
                        <div>Athugaðu að uppgefið verð er aðeins til viðmiðunar</div>
                    </div>
                );
            }
        } else {
            return (
                <div className={'prices'}>
                    <span className="price">Sérpöntunarvara</span>
                </div>
            );
        }
    };

    getShareButtons = () => {
        const FBIcon = (props) => <Icon component={FBSvg} {...props} />;
        const MessengerIcon = (props) => <Icon component={MessengerSvg} {...props} />;
        const PinterestIcon = (props) => <Icon component={PinterestSvg} {...props} />;
        const ArrowIcon = (props) => (
            <Icon
                component={this.state.shareDropdownOpen ? ShareArrowFilledSvg : ShareArrowSvg}
                className="share-arrow-icon"
                {...props}
            />
        );
        const menu = (
            <Menu onClick={() => this.setState({ shareDropdownOpen: false })}>
                <Menu.Item icon={<FBIcon />} key={0}>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href={
                            'https://www.facebook.com/sharer/sharer.php?u=' +
                            encodeURI(window.location.href) +
                            '&amp;src=sdkpreparse'
                        }
                    >
                        Facebook
                    </a>
                </Menu.Item>
                <Menu.Item icon={<MessengerIcon />} key={1}>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href={
                            'http://www.facebook.com/dialog/send?' +
                            'app_id=' +
                            window.facebookAppID +
                            '&link=' +
                            window.location.href +
                            '&redirect_uri=' +
                            window.location.href
                        }
                    >
                        Messenger
                    </a>
                </Menu.Item>
                <Menu.Item icon={<TwitterOutlined />} key={2}>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href={
                            'https://twitter.com/intent/tweet?text=' +
                            encodeURI(window.location.href)
                        }
                    >
                        Twitter
                    </a>
                </Menu.Item>
                <Menu.Item icon={<PinterestIcon />} key={3}>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href={
                            'http://pinterest.com/pin/create/button/?url=' +
                            encodeURI(window.location.href) +
                            '&media=' +
                            window.imageBase +
                            this.state.product.image +
                            '&description=' +
                            encodeURI(this.state.product.name)
                        }
                        className="pin-it-button"
                    >
                        Pinterest
                    </a>
                </Menu.Item>
                <Menu.Item icon={<MailOutlined />} key={4}>
                    <a
                        href={
                            'mailto:?body=Vinur þinn vill senda þér spennandi vöru hjá Tölvutek%0D%0A' +
                            encodeURI(window.location.href)
                        }
                    >
                        Tölvupóstur
                    </a>
                </Menu.Item>
            </Menu>
        );
        return (
            <Dropdown
                overlay={menu}
                overlayClassName="social-share-dropdown"
                className="social-media-buttons"
                onOpenChange={(open) => this.setState({ shareDropdownOpen: open })}
                arrow
            >
                <Button type="link" onClick={(e) => e.preventDefault()}>
                    <ArrowIcon />
                </Button>
            </Dropdown>
        );
    };

    addProductToList = (wishListID, productID) => {
        this.props.store.dispatch(addOrRemoveFromWishList(undefined, productID, null, wishListID));
    };

    isProductOnList = (wishListItems) => {
        let productIds = wishListItems.map((oneItem) => {
            return oneItem.prodId;
        });

        return productIds.includes(this.state.product.id);
    };

    getWishListsDropdown = () => {
        const menu = (
            <Menu>
                <Menu.Item icon={<PlusOutlined />} onClick={this.toggleCreateWishList}>
                    <Button type="link">Nýr listi</Button>
                </Menu.Item>
                {this.state.wishLists.length > 0 && <Menu.Divider />}
                {this.state.wishLists.map((wishList) => {
                    const isProductOnList = this.isProductOnList(wishList.wishListItems);
                    return (
                        <Menu.Item
                            onClick={() =>
                                this.addProductToList(wishList.id, this.state.product.id)
                            }
                            icon={
                                isProductOnList ? (
                                    <CheckOutlined />
                                ) : (
                                    <span
                                        role="img"
                                        className="anticon ant-dropdown-menu-item-icon"
                                    />
                                )
                            }
                        >
                            <Button type="link">{wishList.name}</Button>
                        </Menu.Item>
                    );
                })}
            </Menu>
        );
        return (
            <Dropdown
                overlay={menu}
                overlayClassName="wishList-dropdown"
                className="wishList-buttons"
                onOpenChange={this.handleWishListDropdownOpenChange}
                open={this.state.wishListDropdownOpen}
                arrow
            >
                <Button className="origo-button white" onClick={(e) => e.preventDefault()}>
                    Bæta á mína lista <DownOutlined size={60} />
                </Button>
            </Dropdown>
        );
    };

    handleWishListDropdownOpenChange = (flag) => {
        this.setState({ wishListDropdownOpen: flag });
    };

    toggleCreateWishList = () => {
        this.setState({ createWishListOpen: !this.state.createWishListOpen });
    };

    getUpsellCheckboxes = (insurancesInCartIds) => {
        const selectedUpsell = this.state.selectedUpsell.concat(insurancesInCartIds);
        return (
            <div className={'upsell-available'}>
                <div
                    id="insurance-offer"
                    className="spantext"
                    onClick={() => this.openUpsellModal()}
                >
                    <InfoCircleOutlined /> Bættu við tækjatryggingu eða auka ábyrgð
                </div>
                <Space direction="vertical">
                    <Checkbox
                        checked={insurancesInCartIds.length === 0 && selectedUpsell.length === 0}
                        onChange={(e) => {
                            if (e.target.checked) this.setState({ selectedUpsell: [] });
                        }}
                    >
                        Engin trygging
                    </Checkbox>
                    <Checkbox.Group
                        onChange={(values) => {
                            this.setState({ selectedUpsell: values });
                        }}
                        defaultValue={insurancesInCartIds}
                        value={selectedUpsell}
                    >
                        <Space direction="vertical">
                            {this.state.product.insurancesAvailable.map((oneItem) => (
                                <Checkbox value={oneItem.insurance.id}>
                                    {oneItem.insurance.name}
                                </Checkbox>
                            ))}
                        </Space>
                    </Checkbox.Group>
                </Space>
            </div>
        );
    };

    showUpsell = (insurancesInCartIds) => {
        if (process.env.REACT_APP_STORE === 'store1')
            return this.getUpsellCheckboxes(insurancesInCartIds);
        else
            return (
                <Button
                    type="link"
                    className={'small upsell-button'}
                    onClick={this.openUpsellModal}
                >
                    <ArrowFPIcon style={{ fontSize: 35 }} />{' '}
                    {process.env.REACT_APP_ADD_UPSELL_TEXT_PRODUCTPAGE}
                </Button>
            );
    };

    render() {
        const { sku, name, price, priceInt, specialPrice, specialPriceInt } = this.state;
        const { id, disabled, productType } = this.state.product;
        const specialOrder = this.state.product.custom4;
        let discountInt = priceInt - specialPriceInt;
        let discountPercent = Math.round((discountInt / priceInt) * 100);
        let productAvailable;
        if (process.env.REACT_APP_STORE === 'tolvutek')
            productAvailable =
                this.state.product.quantity > 0 ||
                this.state.product.akureyriQuantity > 0 ||
                this.state.product.reykjavikQuantity > 0 ||
                this.state.product.expected;
        else
            productAvailable = this.state.product.stock10Quantity
                ? this.state.product.stock10Quantity > 0
                : this.state.product.quantity > 0;

        const specialOrderNoPrice =
            specialOrder === 'SpecialOrder' || (specialOrder && !productAvailable);
        let totalQuantity =
            this.state.product.quantity +
            this.state.product.akureyriQuantity +
            this.state.product.reykjavikQuantity;
        let preOrder =
            process.env.REACT_APP_STORE === 'tolvutek' &&
            this.state.product.expected &&
            totalQuantity < 1;
        let formattedDate;
        let startingTime;
        if (this.state.product.productType === 6) {
            if (this.state.product.time) {
                let bookableTime = this.state.product.time.split(';')[0];
                let bookableFactors = bookableTime.split(':');
                if (bookableFactors[1].length < 2) bookableFactors[1] = '0' + bookableFactors[1];
                startingTime = 'kl ' + bookableFactors[0] + ':' + bookableFactors[1];
            }

            if (this.state.product.startDate) {
                let bookableDate = new Date(this.state.product.startDate);
                formattedDate =
                    bookableDate.getDate() +
                    '.' +
                    (bookableDate.getMonth() + 1) +
                    '.' +
                    bookableDate.getFullYear();
            }
        }

        const insurancesInCartIds = this.state.product.insurancesAvailable
            .filter((oneItem) => {
                return oneItem.alreadyInCart;
            })
            .map((oneItem) => {
                return oneItem.insurance.id;
            });

        const getOrigoPrices = () => {
            return (
                <div>
                    <div>
                        {productType === 3 ? (
                            <div className="payment-header">Pakkaverð</div>
                        ) : (
                            <div className="payment-header">Tilboðsverð</div>
                        )}
                        <span className="discount-price">{specialPrice}</span>
                    </div>
                    <div>
                        {productType === 3 ? (
                            <div className="payment-header old-price-header">
                                {process.env.REACT_APP_BUNDLE_FULL_PRICE}
                            </div>
                        ) : (
                            <div className="payment-header old-price-header">
                                {process.env.REACT_APP_OLD_PRICE_TEXT}
                            </div>
                        )}
                        <div className="old-price">{price}</div>
                    </div>
                    <div className={'discount-info'}>
                        Afsláttur:{' '}
                        <span className={'amount'}>{formatNumber(discountInt, true)}</span> (
                        <span className={'amount discount'}>{Math.round(discountPercent)}%</span>)
                    </div>
                </div>
            );
        };

        const getTolvutekPrices = () => {
            return (
                <div className="tolvutek-prices">
                    <div className="price">{formatNumber(specialPriceInt)}</div>
                    <div className="discount-info">
                        <span className="list-price">{formatNumber(priceInt, true, true)}</span>
                        <span className="discount-percent">-{discountPercent}%</span>
                        <span className="discount">- {formatNumber(discountInt, true, true)}</span>
                    </div>
                </div>
            );
        };

        return (
            <div className="payinfo">
                {this.state.product.contentType?.includes('Icecat') ? (
                    <Checkbox
                        className={'comparison-checkbox'}
                        checked={this.state.isInComparison}
                        onChange={(e) => this.updateComparison(e, this.state.product.id)}
                    >
                        Bera saman
                    </Checkbox>
                ) : (
                    ''
                )}
                {name ? <h1 className="prod-name">{name}</h1> : ''}
                {this.state.energyLabel ? (
                    <div className="energy-label-container">
                        <img
                            className="energy-label-arrow"
                            src={
                                'images/content/energyLabels/' +
                                this.state.energyLabel.custom1 +
                                '_Left.png'
                            }
                            alt="Upplýsingar um orkunotkun"
                            onClick={() => this.setState({ energyLabelModalOpen: true })}
                        />
                        <div className="energy-label-right">
                            {sku && <div className="prod-number">Vörunúmer: {sku}</div>}
                            {this.state.energyLabel.custom2 ? (
                                <a
                                    className="energy-label-opener"
                                    target="__blank"
                                    href={this.state.energyLabel.custom2}
                                >
                                    Vöruupplýsingablað
                                </a>
                            ) : (
                                <Button
                                    className="energy-label-opener"
                                    type="link"
                                    onClick={() => {
                                        this.props.openTechnicalDescription();
                                        const yOffset = -100;
                                        const element =
                                            document.getElementById('technical-description');
                                        const y =
                                            element.getBoundingClientRect().top +
                                            window.scrollY +
                                            yOffset;

                                        window.scrollTo({ top: y, behavior: 'smooth' });
                                    }}
                                >
                                    Vöruupplýsingablað
                                </Button>
                            )}
                        </div>
                        <Modal
                            className={'energy-label-modal'}
                            width={500}
                            bodyStyle={{ minHeight: 500 }}
                            open={this.state.energyLabelModalOpen}
                            title="Orkunotkun"
                            onCancel={() => this.setState({ energyLabelModalOpen: false })}
                            style={{ top: '60px' }}
                            footer={null}
                        >
                            {this.state.energyLabel.itemValue.includes('.pdf') ? (
                                <object
                                    title="Orkumiði"
                                    data={this.state.energyLabel.itemValue}
                                    type="application/pdf"
                                    height="900px"
                                    width="100%"
                                />
                            ) : (
                                <Image
                                    className="energy-label"
                                    src={this.state.energyLabel.itemValue}
                                    alt="Orkunotkun tækis"
                                    placeholder={
                                        <div
                                            style={{
                                                marginRight: 'auto',
                                                marginLeft: 'auto',
                                                marginTop: 50,
                                                width: 120,
                                            }}
                                        >
                                            <Spinner size={120} />
                                        </div>
                                    }
                                    preview={false}
                                    width="100%"
                                />
                            )}
                        </Modal>
                    </div>
                ) : (
                    sku && <div className="prod-number">Vörunúmer: {sku}</div>
                )}
                {productType === 6 ? (
                    <div id={'bookable-details'}>
                        <div>
                            <i className="material-icons">location_on</i>{' '}
                            {this.state.product.location}
                        </div>
                        <div>
                            <i className="material-icons">access_time</i>
                            {formattedDate ? formattedDate : ''} {startingTime ? startingTime : ''}
                        </div>
                    </div>
                ) : (
                    ''
                )}
                {disabled === true ? (
                    <div id={'not-for-sale'}>Vara ekki til á lager</div>
                ) : specialOrderNoPrice ? (
                    this.getSpecialOrderPrice(
                        specialOrder,
                        price,
                        priceInt,
                        specialPrice,
                        specialPriceInt,
                        discountInt,
                        discountPercent
                    )
                ) : (
                    <div>
                        {specialPriceInt > 0 && priceInt > specialPriceInt ? (
                            process.env.REACT_APP_STORE === 'tolvutek' ? (
                                getTolvutekPrices()
                            ) : (
                                getOrigoPrices()
                            )
                        ) : (
                            <div>
                                <span className="price">{price}</span>
                            </div>
                        )}
                        {this.state.product.offerNumber ? (
                            <div id={'part-of-offer'}>
                                <b>
                                    Þessi vara er hluti af tilboði{' '}
                                    <a href={'sertilbod?offerId=' + this.state.product.offerNumber}>
                                        {this.state.product.offerNumber}
                                    </a>
                                </b>
                            </div>
                        ) : (
                            ''
                        )}
                        {this.state.defaultPrice ? (
                            <LettkaupLoanCalc price={this.state.defaultPrice} />
                        ) : (
                            ''
                        )}
                    </div>
                )}
                {process.env.REACT_APP_STORE === 'tolvutek'
                    ? this.getTolvutekAvailability()
                    : this.getAvailability()}
                {this.state.product.productType === 3 && process.env.REACT_APP_STORE === 'store1'
                    ? ''
                    : this.getProductNotification(this.state.product.quantity)}
                {this.state.product.insurancesAvailable.length > 0 &&
                    this.showUpsell(insurancesInCartIds)}
                {this.state.product.custom7 &&
                this.state.product.custom7.includes('stk. á mann') ? (
                    <div className={'limited-offer'}>{'Hámark ' + this.state.product.custom7}</div>
                ) : (
                    ''
                )}
                {disabled === true ? (
                    ''
                ) : (
                    <div className={'add-to-cart-buttons'}>
                        {specialOrderNoPrice ? (
                            <Button
                                className="origo-button add-to-cart specialorder"
                                onClick={(e) => this.openChat(e)}
                            >
                                {process.env.REACT_APP_SPECIAL_ORDER_TEXT}
                            </Button>
                        ) : this.state.quantityInCart > 0 ? (
                            <NumberInput
                                quantity={this.state.quantityInCart}
                                updateCart={this.updateCart}
                            />
                        ) : (
                            <Button
                                className={
                                    'origo-button add-to-cart' + (preOrder ? ' preorder' : '')
                                }
                                onClick={async (e) => {
                                    if (this.state.selectedUpsell.length > 0) {
                                        for (const insuranceId of this.state.selectedUpsell) {
                                            await getData('AddToCartFromProdId', {
                                                prodId: insuranceId,
                                                quantity: 1,
                                                prodIdForInsurance: id,
                                            });
                                        }
                                        this.props.store.dispatch(fetchCart(true));
                                    } else {
                                        this.props.store.dispatch(
                                            addToCart(
                                                id,
                                                1,
                                                e,
                                                name,
                                                specialPriceInt ? specialPriceInt : priceInt
                                            )
                                        );
                                    }
                                    this.openUpsellModal();
                                }}
                                disabled={!productAvailable}
                            >
                                {productAvailable
                                    ? preOrder
                                        ? 'Forpanta'
                                        : 'Bæta í körfu'
                                    : 'Fæst ekki í netverslun'}
                            </Button>
                        )}
                        <WishListButton
                            id={id}
                            updateWishList={this.updateWishList}
                            isOnWishList={this.state.isOnWishList}
                            className={'productPage'}
                        />
                        {process.env.REACT_APP_STORE === 'tolvutek' && this.getShareButtons()}
                    </div>
                )}
                {this.props.isLoggedIn && this.getWishListsDropdown()}
                {this.state.product.insurancesAvailable.length > 0 ? (
                    <UpsellModal
                        open={this.state.upsellModalOpen}
                        upsellProducts={this.state.product.insurancesAvailable}
                        hideModal={this.hideUpsellModal}
                    />
                ) : (
                    ''
                )}
                <CreateWishListModal
                    open={this.state.createWishListOpen}
                    toggleOpen={this.toggleCreateWishList}
                    productIDToAdd={this.state.product.id}
                />
            </div>
        );
    }
}

export default ProductPrice;
